import type { PresenceAdapter } from '../interface'
import type { OnlineUser } from '../../../types/user'

const MOCK_USERS: OnlineUser[] = [
  { userId: 'mock-u1', displayName: 'Алексей', lat: 55.758, lng: 37.619, heading: 45, speed: 14, status: 'driving', updatedAt: Date.now() },
  { userId: 'mock-u2', displayName: 'Мария', lat: 55.751, lng: 37.610, heading: 180, speed: 8, status: 'driving', updatedAt: Date.now() },
]

let animFrame: ReturnType<typeof setInterval> | null = null
const subscribers: Array<(users: OnlineUser[]) => void> = []

function animateMockUsers(): void {
  MOCK_USERS.forEach((u) => {
    const rad = (u.heading * Math.PI) / 180
    u.lat += (Math.cos(rad) * u.speed * 4) / 111_320
    u.lng += (Math.sin(rad) * u.speed * 4) / (111_320 * Math.cos((u.lat * Math.PI) / 180))
    u.heading = (u.heading + (Math.random() * 6 - 3)) % 360
    u.updatedAt = Date.now()
  })
  subscribers.forEach((fn) => fn([...MOCK_USERS]))
}

export const mockPresenceAdapter: PresenceAdapter = {
  async publishPresence(): Promise<void> {},
  subscribeToPresence(_geohash, onUpdate): () => void {
    subscribers.push(onUpdate)
    onUpdate([...MOCK_USERS])
    if (!animFrame) animFrame = setInterval(animateMockUsers, 4000)
    return () => {
      const idx = subscribers.indexOf(onUpdate)
      if (idx !== -1) subscribers.splice(idx, 1)
      if (subscribers.length === 0 && animFrame) { clearInterval(animFrame); animFrame = null }
    }
  },
  async removePresence(): Promise<void> {},
}
